import { say } from "../../localization/say.ts";

export type Began = { started: true } | { started: false; why: string };

export type DictationCallbacks = {
  onLevel?: (level: number) => void;
  onFinished?: (text: string) => void;
  onFailed?: (why: string) => void;
};

export type Dictation = {
  start: (callbacks?: DictationCallbacks) => Promise<Began>;

  stop: () => Promise<string>;

  discard?: () => void;
};

export const noDictation: Dictation = {
  start: async () => ({ started: false, why: say("dictation.none") }),
  stop: async () => "",
};

export type Dictating = { recording: boolean; why: string | null };

export const QUIET: Dictating = { recording: false, why: null };

const began = (answer: Began): Dictating =>
  answer.started ? { recording: true, why: null } : { recording: false, why: answer.why };

export async function pressedDictation(
  was: Dictating,
  port: Dictation,
): Promise<{ now: Dictating; said: string }> {
  if (was.recording) return { now: QUIET, said: await port.stop() };
  return { now: began(await port.start()), said: "" };
}

export const dictationLabel = (recording: boolean): string =>
  recording ? say("dictation.stop") : say("dictation.start");

export function withDictated(text: string, said: string): string {
  const words = said.trim();
  if (!words) return text;
  if (!text) return words;
  return /\s$/.test(text) ? `${text}${words}` : `${text} ${words}`;
}
